/**
 * Texto que vira nome de arquivo ou identificação segura no sistema.
 * Mantém letras (A–Z, a–z + Latin-1 / Latin Extended-A), números e espaço.
 */

/** Limite alinhado a nomes de arquivo / chaves e boas práticas de UI. */
export const DOCUMENT_NAME_MAX_LENGTH = 128;

/** Mesmo teto do nome do documento para consistência no fluxo de assinatura. */
export const SIGNER_NAME_MAX_LENGTH = 128;

const DOCUMENT_NAME_CHAR = /[A-Za-z0-9\s\u00C0-\u017F]/;

function filterAllowedChars(value: string): string {
  if (value == null || value === "") return "";
  return Array.from(value)
    .filter((char) => DOCUMENT_NAME_CHAR.test(char))
    .join("");
}

export function filterDocumentNameInput(value: string): string {
  return filterAllowedChars(value ?? "").slice(0, DOCUMENT_NAME_MAX_LENGTH);
}

export function filterSignerNameInput(value: string): string {
  return filterAllowedChars(value ?? "").slice(0, SIGNER_NAME_MAX_LENGTH);
}
